import React from 'react';
import PropTypes from 'prop-types';
import { indexOf } from 'lodash';
import cn from 'classnames';
import { ScrollableContainer } from 'legacy-packages/ft-cb';
import CheckBox from 'chameleon/ui-stack/ui/base/checkbox';
import A11y from 'chameleon/ui-stack/utilities/a11y';

/**
 * Draws the left box with selection items
 * */
const SelectionBox = (props) => {
  const { className, items, selectedItems, assignedToItems, onItemClick } =
    props;

  const onCheckBoxClick = (id) => {
    onItemClick(id);
  };

  const renderTrackHorizontal = () => <div />;

  return (
    <ScrollableContainer
      className={className}
      renderTrackHorizontal={renderTrackHorizontal}
    >
      {items.map((c) => {
        const assignedToItem = assignedToItems[c.id];

        let checked = false;
        if (selectedItems.length) {
          checked = indexOf(selectedItems, c.id) > -1;
        }

        return (
          <A11y key={c.id}>
            <button
              onClick={() => onCheckBoxClick(c.id)}
              tabIndex={0}
              className={cn(
                'bg-white w-full h-16.8 mr-2 flex gap-x-4 items-center pl-4.6 ring-inset hover:bg-blue-100',
                {
                  'bg-blue-100': checked,
                },
                'text-black text-14 font-medium',
              )}
            >
              <CheckBox checked={checked} disabled={assignedToItem} />
              {c.name}
              {assignedToItem ? 'circle_warn ICON' : null}
            </button>
          </A11y>
        );
      })}
    </ScrollableContainer>
  );
};

SelectionBox.displayName = 'SelectionBox';

SelectionBox.propTypes = {
  className: PropTypes.string,
  items: PropTypes.array.isRequired,
  selectedItems: PropTypes.array,
  assignedToItems: PropTypes.array,
  onItemClick: PropTypes.func.isRequired,
};

SelectionBox.defaultProps = {
  className: 'user_classes',
  items: [],
  selectedItems: [],
  assignedToItems: [],
};

export default SelectionBox;
